import { Navigate, useParams } from 'react-router-dom';

/**
 * ClubSettingsMembersRedirect - Legacy Route Handler
 *
 * Issue #1227: Members management unified into ClubMembersPage
 * Redirects /clubs/:slug/settings/members → /clubs/:slug/members
 */
export default function ClubSettingsMembersRedirect() {
  const { slug } = useParams<{ slug: string }>();

  // Dev-only tracking for legacy route usage
  if (import.meta.env.DEV) {
    console.warn('[Legacy Route] /clubs/:slug/settings/members → /clubs/:slug/members', { slug });
  }

  return <Navigate to={`/clubs/${slug}/members`} replace />;
}
